// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel,\n.v-input {\n  font-size: 14px !important;\n}\n#datepicker-etat-au {\n  width: 140px !important;\n}\n.v-input--selection-controls__input {\n  margin-right: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
